module.exports = __webpack_public_path__ + "static/media/hall-of-fun.ecd467ca.ttf";